import { useState, useEffect, useCallback } from "react";

type Lang = "en" | "es";

const STORAGE_KEY = "app-lang";
const listeners = new Set<(lang: Lang) => void>();

function getStoredLang(): Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "es") return stored;
  } catch {}
  return "en";
}

export function useLanguage() {
  const [lang, setLangState] = useState<Lang>(getStoredLang);

  useEffect(() => {
    const handler = (newLang: Lang) => setLangState(newLang);
    listeners.add(handler);
    return () => { listeners.delete(handler); };
  }, []);

  const setLang = useCallback((newLang: Lang) => {
    localStorage.setItem(STORAGE_KEY, newLang);
    setLangState(newLang);
    listeners.forEach(fn => fn(newLang));
  }, []);

  const toggleLang = useCallback(() => {
    const newLang: Lang = lang === "en" ? "es" : "en";
    setLang(newLang);
  }, [lang, setLang]);

  return { lang, setLang, toggleLang };
}
